/**
 * 用户权限模块的接口
 * */
import base from './base' // 接口域名列表
import axios from '@/utils/http' // 导入创建的axios实例
import qs from 'qs' // 序列化post请求的
import constant from '../utils/constant'

let www = base.proxy

axios.defaults.headers.common['token'] = constant.getToken()

// 开始定义接口
const userPermission = {
  userRoleTypeListApi () {
    return axios.post(`${www}/wtapi/external/api/userRole/list/apiType`)
  },
  userRoleListApi () {
    return axios.post(`${www}/wtapi/external/api/userRole/list/api`)
  },
  setUserRoleApi (params) {
    return axios.post(`${www}/wtapi/external/api/userRole/changeSwitch/api`, qs.stringify({switchIds: params}), {
      header: {
        'Content-Type': 'application/json'
      }
    })
  }
}

export default userPermission



// WEBPACK FOOTER //
// ./src/api/userPermission.js